import React from 'react';
import { useSelector } from 'react-redux';
import truncate from 'truncate-markup-string';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import './style.scss';

const NodeArticleTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const imgSrc = entity.getIn(['field_image', 0, 'styles', 'cropped_small_3_2']);
  const imgAlt = entity.getIn(['field_image', 0, 'title']);
  const articleType = entity.getIn(['field_article_type', 0, 'entity', 'name', 0, 'value']);
  const articleDate = new Date(
    entity.getIn(['created', 0, 'value'])).toLocaleDateString(
    'nl-NL',
    {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    },
  );
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const path = entity.getIn(['paths', currentLanguage]);

  const charLimit = 100;
  const openTag = '<span>';
  const closeTag = '</span>';
  const prettyEllipsis = true;

  return (
    <div className="NodeArticleTeaser">
      <CoreLink to={path}>
        <div className="NodeArticleTeaser__image__wrapper">
          <div className="NodeArticleTeaser__icon">
            <div className={`icon icon-${articleType.toLowerCase().split('/')[0]} icon-variant-1`} />
          </div>
          <Image
            className="NodeArticleTeaser__image"
            src={imgSrc}
            alt={imgAlt}
            lazyload={false}
          />
        </div>
        <h4>{title}</h4>
        <div className="NodeArticleTeaser__date">
          <div className="NodeArticleTeaser__date__date">
            {articleDate}
          </div>
        </div>
        <WysiwygField
          property="schema:text"
          html={truncate(body, charLimit, openTag, closeTag, prettyEllipsis)}
        />
      </CoreLink>
    </div>
  );
};

export default NodeArticleTeaser;
